import React, { useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import './ReadMore.scss';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

type Props = {
  text?: string | null | undefined;
  lines?: number;
};

const ReadMore: React.FC<Props> = ({ text, lines = 3 }) => {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const checkClamping = () => {
      const element = textRef.current;
      if (element) {
        const currentStyle = window.getComputedStyle(element);
        const lineClamp = parseInt(
          currentStyle.getPropertyValue('-webkit-line-clamp'),
          10
        );

        if (
          lineClamp > 0 &&
          currentStyle.getPropertyValue('overflow') === 'hidden'
        ) {
          setIsClamped(element.scrollHeight > element.clientHeight);
        } else {
          setIsClamped(false);
        }
      }
    };

    checkClamping();

    window.addEventListener('resize', checkClamping); // Handle resizing
    return () => window.removeEventListener('resize', checkClamping);
  }, [text]);
  return (
    <div>
      <p
        ref={textRef}
        className={expanded ? 'expanded' : `clamped clamped-${lines}`}
      >
        {<ReactMarkdown>{text}</ReactMarkdown>}
      </p>
      {(isClamped || expanded) && (
        <button
          onClick={() => setExpanded(!expanded)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          {expanded ? (
            <FaChevronUp aria-label="Collapse text" title="Collapse text" />
          ) : (
            <FaChevronDown aria-label="Expand text" title="Expand text" />
          )}
        </button>
      )}
    </div>
  );
};

export default ReadMore;
